import React from 'react';
import Offers from './Offers';
import GroupedProducts from './GroupedProducts';
import { Container, Typography } from '@mui/material';
import { useCart } from './CartContext';
import { isBranchOpen } from './branchUtils';
import ClosedMessage from './ClosedMessage';

export default function OffersPage() {
  const { selectedBranch } = useCart();
  const [branchStatus, setBranchStatus] = React.useState({ isOpen: true, nextOpen: '' });

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  React.useEffect(() => {
    if (selectedBranch) {
      setBranchStatus(isBranchOpen(selectedBranch));
    }
  }, [selectedBranch]);

  if (!branchStatus.isOpen) {
    return <ClosedMessage openTime={branchStatus.nextOpen} />;
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <GroupedProducts />
      <Offers />
    </Container>
  );
}
